import type { RouteObject } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';
import Home from '@/pages/home/page';
import CategoryPage from '@/pages/category/page';
import DetailPage from '@/pages/detail/page';
import SearchPage from '@/pages/search/page';
import AboutPage from '@/pages/about/page';
import FaqPage from '@/pages/faq/page';
import NotFound from '@/pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: 'category/:type', element: <CategoryPage /> },
      { path: 'detail/:id', element: <DetailPage /> },
      { path: 'search', element: <SearchPage /> },
      { path: 'about', element: <AboutPage /> },
      { path: 'faq', element: <FaqPage /> },
      { path: '*', element: <NotFound /> },
    ],
  },
];

export default routes;